import { type FC, useEffect } from 'react';
import { default as useMeasure } from 'react-use-measure';
import { motion, useMotionValue, animate } from 'motion/react';
import { clsx } from '@team/clsx';
import { type Props } from './types';
import css from './style.module.css';

export const Entry: FC<Props> = ({
  children,
  speed = 100,
  gap = 8,
  reverse = false,
  className,
}) => {
  const translation = useMotionValue(0);
  const [ref, { width }] = useMeasure();

  useEffect(() => {
    const size = width;
    const contentSize = size + gap;
    const from = reverse ? -contentSize / 2 : 0;
    const to = reverse ? 0 : -contentSize / 2;

    const distanceToTravel = Math.abs(to - from);
    const duration = distanceToTravel / speed;

    const controls = animate(translation, [from, to], {
      ease: 'linear',
      duration: duration,
      repeat: Infinity,
      repeatType: 'loop',
      repeatDelay: 0,
      onRepeat: () => {
        translation.set(from);
      },
    });

    return controls.stop;
  }, [translation, width, gap, reverse, speed]);

  return (
    <div className={clsx(className, css.root)}>
      <motion.div
        className={css.inner}
        ref={ref}
        style={{
          gap,
          x: translation,
        }}
      >
        {children}
        {children}
      </motion.div>
    </div>
  );
};
